import { boot } from '@dazn/bootstrap-lib';

import { BRANDS, chapterNames } from '../configuration/constants';

export interface HandleTokenResetProps {
    checkRegionAvailability: () => boolean;
    getBrandName: () => boot.brand.BrandName;
    setCurrentChapter: (
        chapter: boot.config.ChapterNameLike,
    ) => Promise<unknown> | void;
    onLogoutChapterConfig: boot.config.ChapterName;
}

const getProductGroupFromPath = (pathname: string): string | null => {
    const contentMatch = pathname.match(/\/content\/([^/?#]+)/i);
    if (contentMatch && contentMatch[1]) {
        return contentMatch[1];
    }
    return null;
};

export const handleTokenReset = ({
    checkRegionAvailability,
    getBrandName,
    setCurrentChapter,
    onLogoutChapterConfig,
}: HandleTokenResetProps) => {
    localStorage.removeItem('partnerToken');
    (global as any).PARTNER_TOKEN = '';

    if (!checkRegionAvailability()) {
        window.location.href = '/signin';
        return;
    }
    const forcedPostLoginValue = localStorage.getItem('forcePostLogoutUrl');
    if (forcedPostLoginValue) {
        localStorage.removeItem('forcePostLogoutUrl');
        window.location.href = forcedPostLoginValue;
        return;
    }
    const brandName = getBrandName();
    if (brandName === BRANDS.DAZN) {
        const currentPath = window.location.pathname;
        const productGroup = getProductGroupFromPath(currentPath) || 'dazn';
        const chapterPath = `account/content/${productGroup}/signup?signin=true&userLoggedOut=true`;
        setCurrentChapter({
            chapterName: chapterNames.AUTH_SIGNIN.dazn,
            chapterPath,
        });
        return;
    }
    const onLogoutChapter = brandName
        ? brandName === BRANDS.FOXSPORTS
            ? chapterNames.NEWS
            : brandName !== BRANDS.DAZN
            ? chapterNames.LANDING_PAGE
            : chapterNames.AUTH_SIGNIN[brandName]
        : onLogoutChapterConfig;
    setCurrentChapter(onLogoutChapter);
};
